import sx from 'utils/createSx';

export default sx({
  verticalContainer: {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  innerStack: { width: '100%' },
  submitProgress: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1.5,
  },
});
